/**
 * Scroll smoothly to the given selector.
 * @param {string|Element} selector
 * @param {number} [time]
 * @param {number} [offset]
 */
export default function smoothScrollTo (selector, time = 500, offset = -100) {
    const $target = $(selector).first();
    if (!$target.length) return;

    const max = $(document).height() - $(window).height();
    const scrollTop = Math.min(max, $target.offset().top + offset);

    $('html, body').stop(true).animate({ scrollTop }, time);
}



// WEBPACK FOOTER //
// ./src/scripts/components/global/smoothScrollTo.js